/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDto';
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto(value) {
    if (!('Geo' in value) || value['Geo'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Geo': FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoFromJSON(json['geo']),
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'geo': FxIdApplicationHandlersNativeStatusNativeStatusGeoDataDtoToJSON(value['Geo']),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoTrackDto.js.map